import { render, staticRenderFns } from "./pointLog.vue?vue&type=template&id=0d5bcb32&scoped=true"
import script from "./pointLog.vue?vue&type=script&lang=js"
export * from "./pointLog.vue?vue&type=script&lang=js"
import style0 from "./pointLog.vue?vue&type=style&index=0&id=0d5bcb32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5bcb32",
  null
  
)

export default component.exports